import { useBreakpoints } from "./use-breakpoints"

export function useIsSmallScreen() {
  const { xs, sm } = useBreakpoints()

  return xs || sm
}
